import * as React from 'react';
import { IArticleListCard } from 'models/magazine/article/articlelistcard';
import { IItemCardProps } from 'models/itemcard';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { thumbUrl, truncateText } from 'helpers/common';
import { INodeData } from 'models/common';
require('./style.css');

interface IProps extends IItemCardProps {
	item: IArticleListCard;
	t?: (key: string) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class MagazineArticleItemSmallCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.goToCard = this.goToCard.bind(this);
	}

	public goToCard(e: any) {
		e.preventDefault();
		if (this.props.goToCard) {
			const entityIdObj: INodeData = JSON.parse(this.props.item.entityId);
			this.props.goToCard(entityIdObj.id, entityIdObj.type);
		}
	}

	public render() {
		const { item, t } = this.props;
		const id = JSON.parse(item.entityId).id;

		return (
			<div key={id} className="magazineArticleItemSmallCard">
				<div className="innerHolder">
					<a href="#" onClick={this.goToCard} className="image">
						<span style={{ backgroundImage: `url(${thumbUrl(item.picture)})` }} />
					</a>
					<div className="textContent">
						<div className="title desktopShown">
							<a href="#" onClick={this.goToCard}>
								{truncateText(item.name, 40)}
							</a>
						</div>
						<div className="author">
							<span className="byText">{t('Magazine_Section_Common_By')} </span>
							<span className="text">{item.addedBy}</span>
						</div>
					</div>
					<div className="clear" />
				</div>
			</div>
		);
	}
}

export { MagazineArticleItemSmallCard };
